import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as accountStore from "@containers/Account/store";
import { hasAccountActiveSubscription } from "@shared/utils";
import "./CustomerManager.scss";
import { getAccountScmManagerAction } from "@containers/Account/store/actions";
import classNames from "classnames";
import { checkIfAdmin } from "@shared/utils/ACL";

export const CustomerManager = () => {
  const dispatch = useDispatch();
  const isAdmin = checkIfAdmin();
  const account = useSelector(accountStore.selectors.getActiveAccount());
  const hasActiveSubscription = hasAccountActiveSubscription(account);
  const scmManager = useSelector(accountStore.selectors.getScmManager());

  useEffect(() => {
    if (!account?.id || !hasActiveSubscription || isAdmin) {
      dispatch(getAccountScmManagerAction.success(null));

      return;
    }

    dispatch(getAccountScmManagerAction.request({ id: account.id }));
  }, [dispatch, account?.id, hasActiveSubscription, isAdmin]);

  if (!scmManager) return null;

  const name = `${scmManager.firstName} ${scmManager.lastName}`;

  return (
    <div className={classNames("customer-manager", { "without-avatar": !scmManager.avatar })}>
      <div className="customer-manager-title">CUSTOMER SUCCESS MANAGER</div>

      <div className="customer-manager-info">
        {!!scmManager.avatar && (
          <div className="customer-manager-image">
            <img src={scmManager.avatar} alt="avatar" />
          </div>
        )}
        <div className="customer-manager-text">
          <div className="customer-manager-name">{name}</div>

          <div className="customer-manager-email">
            <a href={`mailto:${scmManager.email}`}>{scmManager.email}</a>
          </div>
        </div>
      </div>
    </div>
  );
};
